module.exports = __webpack_public_path__ + "img/防伪溯源.89f6ee6c.png";